import { dollarsToCents, toTaxRate } from "src/main/Billing/Items/helpers"

import { calculateItemizedTaxTotal } from "src/utils/tax_calculation"

export const calculateCancellationFeeTotal = (feeValue, feeTaxRate) => {
  const amountAsCents = dollarsToCents(feeValue)

  if (feeTaxRate) {
    const taxRate = toTaxRate(feeTaxRate)
    const taxAmountInCents = Math.round(amountAsCents * taxRate)
    return amountAsCents + taxAmountInCents
  }
  return amountAsCents
}

export const calculateItemizedCancellationFeeTotal = (feeValue, taxes) => {
  const amountAsCents = dollarsToCents(feeValue)
  const taxTotal = calculateItemizedTaxTotal(amountAsCents, taxes)
  return amountAsCents + taxTotal
}
